var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputCheckbox',{attrs:{"model":_vm.isSelected},nativeOn:{"click":function($event){$event.preventDefault();return _vm.select()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }